import { useState } from 'react';
import { MonthYear, months } from '../../../../../../utils/MonthYear/monthYear';
import { DeliveryDatesOverlay } from '../DeliveryDatesOverlay/DeliveryDatesOverlay';
import EventIcon from '@mui/icons-material/Event';
import React from 'react';

interface IDeliveryDatePickerProps {
  quantity: number;
  deliveryDates: MonthYear[];
  setDeliveryDates: (_dates: MonthYear[] | undefined) => void;
  isDisabled?: boolean;
}
export const DeliveryDatePicker: React.FC<IDeliveryDatePickerProps> = ({
  deliveryDates,
  quantity,
  setDeliveryDates,
  isDisabled = false,
}) => {
  const [toggleSelectDeliveryDatesOverlay, setToggleSelectDeliveryDatesOverlay] = useState(false);
  return (
    <div className="min-w-52 ">
      <div className="flex gap-2 ">
        <button
          disabled={isDisabled}
          title="set dates"
          defaultValue={quantity || ''}
          className={`flex justify-between text-base rounded border-gray-450 p-[1px] w-full ${
            isDisabled ? '' : 'border-1'
          }`}
          onClick={() => setToggleSelectDeliveryDatesOverlay(true)}
        >
          <div className={`text-base p-1 ${deliveryDates?.length > 0 ? 'text-black' : 'text-gray-400'} my-auto`}>
            {deliveryDates && deliveryDates.length > 0 ? deliveryDatesToString(deliveryDates) : 'Select date or range'}
          </div>
          <EventIcon sx={{ color: '#6571FF' }} />
        </button>
        {toggleSelectDeliveryDatesOverlay && (
          <DeliveryDatesOverlay
            toggleOverlayOff={() => setToggleSelectDeliveryDatesOverlay(false)}
            setDateOrRange={setDeliveryDates}
            dateOrRange={deliveryDates}
          />
        )}
      </div>
    </div>
  );
};

export const deliveryDatesToString = (dates: MonthYear[]): string => {
  if (dates.length === 1) {
    return `${months[dates[0].month]} ${dates[0].year}`;
  }
  const [fromDate, toDate] = dates || [];
  const fromStr = fromDate ? `${months[fromDate.month - 1]} ${fromDate.year}` : '';

  return toDate ? `${fromStr} - ${months[toDate.month - 1]} ${toDate.year}` : fromStr;
};
